<div class="row" [formGroup]="expensesForm">
    <div class="col">
        <accordion>
            <!-- accordionItems for confirmation expenses-->
            <ng-container *ngrxLet="notificationInfo$; let notificationInfo">
                @if (notificationInfo) {
                    @for (expense of model.expensesDictionary | keyvalue; track expense) {
                        <accordion-group
                            [isOpen]="notificationInfo[expense.key]?.isOpen ?? false"
                            (isOpenChange)="
                                notificationInfo[expense.key] && (notificationInfo[expense.key].isOpen = $event)
                            "
                        >
                            <div accordion-heading [formGroup]="expensesEntriesFormChildren[expense.key]">
                                @if (notificationInfo[expense.key]?.isOpen) {
                                    <fa-icon [icon]="faChevronDown" size="lg"></fa-icon>
                                }
                                @if (!notificationInfo[expense.key]?.isOpen) {
                                    <fa-icon [icon]="faChevronRight" size="lg"></fa-icon>
                                }
                                <h4 class="ps-2">{{ notificationInfo[expense.key]?.title ?? '' }}</h4>
                            </div>
                            <div class="col-12 col-lg-10 offset-lg-1">
                                <div class="row mb-3">
                                    <label
                                        class="col-4 col-lg-2 text-start text-lg-end col-form-label"
                                        translate="TIMESHEET_EXPENSES_DISTANCE_LABEL"
                                    ></label>
                                    <div class="col col-lg-3">
                                        @if (notificationInfo[expense.key]?.notification?.qmNum) {
                                            <pace-core-text-input
                                                [(model)]="distance[expense.key]"
                                                [parentForm]="expensesEntriesFormChildren[expense.key]"
                                                [ariaLabel]="'TIMESHEET_EXPENSES_DISTANCE_LABEL' | translate"
                                            ></pace-core-text-input>
                                        }
                                        @if (!notificationInfo[expense.key]?.notification?.qmNum) {
                                            <pace-core-text-input
                                                [(model)]="model.additionalDistance"
                                                [parentForm]="expensesEntriesFormChildren[expense.key]"
                                                [ariaLabel]="'TIMESHEET_EXPENSES_DISTANCE_LABEL' | translate"
                                            ></pace-core-text-input>
                                        }
                                    </div>
                                </div>
                                <hr class="separator" />
                                <div class="row mb-3">
                                    <label
                                        class="col-12 col-md-4 col-lg-2 text-start text-lg-end col-form-label"
                                        translate="CONFIRMATION_EXPENSES_LABEL"
                                    ></label>
                                    <div class="col-md-8 col-12">
                                        @if (notificationInfo[expense.key]) {
                                            <pace-expenses-list
                                                [notificationIdentifier]="notificationInfo[expense.key].notification"
                                                [expenses]="expense.value"
                                                [readonly]="model.readonly"
                                                [parentForm]="expensesEntriesFormChildren[expense.key]"
                                            ></pace-expenses-list>
                                        }
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                    }
                }
            </ng-container>
        </accordion>
    </div>
</div>
